import Vue from 'vue';
import {
  getInvitations
} from '../../../services/backendService/invitationsService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  invitations: [],
  pagination: {
    current_page: 0,
    per_page: 5
  }
};

 // actions
const actions = {
  //* *** 後台邀請函 ****//
  // 取得後台邀請函
  async getInvitationsHandler({ commit }, formData) {
    const data = await getInvitations(formData);
    commit('setInvitations', data);
  }
};

// mutations
const mutations = {
  setInvitations(state, data) {
    Vue.set(state, 'invitations', state.invitations.concat(data.data.data));
    Vue.set(state, 'pagination', data.pagination);
  },
  // 重置分頁
  resetInfiniteLoadingData(state) {
    Vue.set(state, 'invitations', []);
    Vue.set(state, 'pagination', {
      current_page: 0,
      per_page: 5
    });
  }
};

 export default {
   namespaced: true,
   state,
   actions,
   mutations
 };
